/** The field's name inside the box, above the value; kept while typing. */
export function InlineLabel({ text, htmlFor }: { text: string | undefined; htmlFor: string | undefined }): React.JSX.Element | null {
  if (!text) return null;
  return (
    <label className="nb-input-label" htmlFor={htmlFor}>
      {text}
    </label>
  );
}
